import { NavItemBaseProps } from 'src/layouts/main/nav/types';

export const navConfig: NavItemBaseProps[] = [
  { title: 'About Us', path: '#about-us' },
  { title: 'Technologies', path: '#technologies' },
  { title: 'Services', path: '#our-services' },
  { title: 'Projects', path: '#case-studies' },
];
